<template>
  <div class="container-agreement">
    <el-row type="flex" justify="center" class="wrap-row">
      <el-col :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
        <h2>{{$t('guestID.specialTitle')}}</h2>
        <div class="content">
          <h3>{{$t('guestID.leaseInformation')}}</h3>
          <div class="item">
            <div class="title">{{$t('guestID.propertyName')}}</div>
            <p>{{identificationInfo.propertyName}}</p>
          </div>
          <div class="item">
            <div class="title">{{$t('guestID.leasePeriod')}}</div>
            <p>{{`${identificationInfo.checkIn}-${identificationInfo.checkOut}`}}</p>
          </div>
          <div class="item" style="overflow: hidden;">
            <div class="title">{{$t('guestID.rent')}}</div>
            <div style="float:left">
              <p>{{$t('guestID.facilityUsagefee')}}：{{`${identificationInfo.roomRate}`}}</p>
              <p>{{$t('guestID.cleaningFee')}}：{{identificationInfo.cleanFee}}</p>
              <p>{{$t('guestID.total')}}：{{identificationInfo.total}}</p>
            </div>
            <div  style="float:right">
              <p>{{identificationInfo.currency}}{{$t('guestID.taxIncluded')}}</p>
              <p>{{identificationInfo.currency}}{{$t('guestID.taxIncluded')}}</p>
              <p>{{identificationInfo.currency}}</p>
            </div>
          </div>
          <div class="item">
            <div class="title">{{$t('guestID.leaseExecutionDate')}}</div>
            <p>{{identificationInfo.checkIn}}</p>
          </div>
        </div>
        <div :class="{'agreement': true, 'hidden': isMore}" v-html="$t('guestID.agreementDesc')"></div>
        <div class="more">
          <span @click="isMore = !isMore">{{ isMore ? `${$t('guestID.expand')}` :  `${$t('guestID.collapse')}` }}</span>
          <i v-if="isMore" class="el-icon-arrow-down" ></i>
          <i v-else class="el-icon-arrow-up"></i>
        </div>
        <div class="content">
          <h3>{{$t('guestID.Lessor')}}</h3>
          <div class="item">
            <div class="title">{{$t('guestID.corporationName')}}</div>
            <p>{{identificationInfo.corporationName}}</p>
          </div>
          <div class="item">
            <div class="title">{{$t('guestID.corporationAddress')}}</div>
            <p>{{identificationInfo.corporationAddress}}</p>
          </div>
          <div class="item">
            <div class="title">{{$t('guestID.representativeDirector')}}</div>
            <p>{{identificationInfo.representativeDirector}}</p>
          </div>
           <div class="item" v-if="identificationInfo.invoiceIssuerNumber">
              <div class="title">{{$t('guestID.invoiceIssuerNumber')}}</div>
              <p>{{identificationInfo.invoiceIssuerNumber}}</p>
            </div>
        </div>
        <div class="content-box">
          <div class="content" v-for="(item,index) in identificationInfo.identifications" :key="index">
            <h3>
              <span>{{$t('guestID.Lessee')}}</span>
              <i v-if="index !== 0 && !item.id" class="el-icon-delete" style="color:#FF0000;cursor: pointer;" @click="deleteIdentifications(index)"></i>
            </h3>
            <div class="item">
              <div class="title">{{$t('guestID.name')}}<span>*</span></div>
              <el-input placeholder="Please input" v-model="item.guestName" :disabled="item.status == 'PASS'"></el-input>
            </div>
            <div class="item">
              <div class="title">{{$t('guestID.address')}}<span>*</span></div>
              <el-input placeholder="Please input" v-model="item.guestAddress" :disabled="item.status == 'PASS'"></el-input>
            </div>
            <div class="item">
              <div class="title">{{$t('guestID.phone')}}<span>*</span></div>
              <el-input placeholder="Please input" v-model="item.guestPhone" :disabled="item.status == 'PASS'"></el-input>
            </div>
            <div class="item">
              <div class="title">{{$t('guestID.nationality')}}<span>*</span></div>
              <el-input placeholder="Please input" v-model="item.guestNationality" :disabled="item.status == 'PASS'"></el-input>
            </div>
            <div class="item">
              <div class="title">{{$t('guestID.passportNumber')}}<span>*</span></div>
              <el-input placeholder="Please input" v-model="item.number" :disabled="item.status == 'PASS'"></el-input>
            </div>
            <div class="item">
              <div class="title">{{$t('guestID.photo')}}<span>*</span></div>
              <Upload v-if="item.status != 'PASS'" :imgInfo="item" @successHandle="successHandle" :index="index"></Upload>
              <img v-else :src="item.img.url" class="avatar">
              <p class="tip-desc" v-if="item.status === 'REJECTED'"><i class="el-icon-circle-close"></i>{{item.rejectReason == 'NOT_PASSPORT' ? $t('guestID.notPassport') : $t('guestID.imgNOtClear')}}</p>
            </div>
          </div>
        </div>
        <div class="button">
          <el-button type="primary" icon="el-icon-circle-plus-outline" plain round @click="addIdentificationInfo">{{$t('guestID.addGuest')}}</el-button>
          <el-button type="primary" style="margin-top:60px;width:200px;margin-bottom: 30px;" @click="submitHandle">{{$t('guestID.confirm')}}</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Upload from '@/components/identification/Upload.vue'
import { update } from '@/api/identification'
const i18n = 'guestID.'
export default {
  name: 'special',
  components: { Upload },
  props: {
    identificationInfo: Object,
  },
  data () {
    return {
      openOrderId: null,
      referenceUrl: 'https://ostay-open-img.oss-ap-northeast-1.aliyuncs.com/resources/img/open/reference/passport.jpg',
      isMore: true,
      identifications: [],
    }
  },
  methods: {
    successHandle (fileInfo) {
      console.log(fileInfo)
      this.identificationInfo.identifications[fileInfo.index].img = {
        id: fileInfo.id.toString(),
        url: `https://ostay-test.oss-ap-northeast-1.aliyuncs.com/${fileInfo.fileKey}`,
      }
    },
    addIdentificationInfo () {
      this.identificationInfo.identifications.push({
        id: null,
        guestName: null,
        guestAddress: null,
        guestPhone: null,
        guestNationality: null,
        number: null,
        img: null,
        status: null,
        rejectReason: null,
      })
    },
    deleteIdentifications (index) {
      this.identificationInfo.identifications.splice(index, 1)
    },
    submitHandle () {
      const checkObjList = ['guestName', 'guestAddress', 'guestPhone', 'guestNationality', 'number', 'img']
      console.log(this.identificationInfo.identifications)
      const result = this.identificationInfo.identifications.find(item => {
        for (const key in item) {
          if (checkObjList.includes(key) && !item[key]) return item
        }
      })
      if (result) {
        this.$message.error(this.$t(`${i18n}confirmTip`))
        return
      }
      console.log(result)
      const info = this.$cookie.getCustomerInfo()
      update({
        identifications: this.identificationInfo.identifications.map(item => {
          return {
            imgId: item.img.id,
            guestAddress: item.guestAddress,
            guestName: item.guestName,
            id: item.id,
            guestPhone: item.guestPhone,
            guestNationality: item.guestNationality,
            number: item.number,
          }
        }),
        token: info.token,
      }).then(res => {
        if (res.errCode === '200') {
          this.$emit('upload-success')
          this.$message.success(res.errMsg)
          this.$emit('getList')
          console.log(res.data)
        } else {
          this.$message.error(res.errMsg)
        }
      })
    },
  },
}
</script>

<style lang="scss">
.container-agreement {
  background-color: #F5F7FA;
   p,h2,h3 {
    margin: 0;
    padding: 0 ;
   }
   /deep/.el-input__inner {
  border: none !important;
  background-color: #F5F7FA;
  padding: 0;
}
/deep/.el-input__inner::placeholder {
  color: rgba(34, 37, 43, 0.35);
  font-weight: bold;
}
  h2 {
    font-size: 14px;
    color: #22252B;
    text-align: center;
    background-color: #fff;
    padding: 15px 0;
  }
  h3 {
    color:#B59459;
    font-size: 18px;
    font-weight: bold;
    padding: 20px 0 15px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content {
    padding: 0 14px;
    .item {
      padding: 15px 0;
      border-bottom: 1px solid #E4E6E9;
    }
    p {
      color: #22252B;
      font-size: 16px;
      font-weight: bold;
      line-height: 22px;
    }
    .tip-desc {
      color: #EB4D4D;
      font-size: 14px;
    }
    .title {
      display: flex;
      align-items: center;
      gap:4px;
      color:#818388;
      font-size: 14px;
      margin-bottom: 10px;
      font-weight: bold;
      span {
        color: #F00;
      }
    }
    .title::before {
      content: '';
      display: flex;
      width: 2px;
      height: 13px;
      flex-direction: row;;
      background-color: #B59429;
    }
  }
  .agreement {
    white-space: normal;
    color: #22252B;
    padding: 0 14px;
    div {
      margin-bottom: 5px;
    }
    .title {
      font-size: 15px;
      font-weight: bold;
    }
    .sub-title {
      font-size: 14px;
      font-weight: normal;
      font-weight: 400;
    }
    .content {
      font-size: 14px;
      line-height: 20px;
    }
  }
  .avatar-uploader {
  .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 98px;
  line-height: 98px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 98px;
  display: block;
}
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  flex-direction: column;
}
.hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.more {
  text-align: center;
  color: #B59429;
  font-weight: bold;
  margin-top: 7px;
}
.avatar {
  width: 178px;
  height: 98px;
  display: block;
  object-fit: contain;
}
}
</style>
